import React, { useEffect, useState } from 'react'
import ContactInformationView from './components/ContactInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import { useSelector } from 'react-redux';

const ContactInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  const addressTypeChange = useSelector((state) => state.app.addressTypeChange);
  useEffect(() => {
    try {
      addToGoogleDataLayer('contact-information', 'Change of Address', i18n.language, addressTypeChange)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language, addressTypeChange])

  return isError ? <Error /> : <ContactInformationView setIsError={setIsError} />
}

export default withTranslation('common')(ContactInformation)
